var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3048 27.9927L53.124 20.1259C52.6796 19.7452 51.9933 20.0608 51.9933 20.646V24.3686C51.9933 24.3686 34.9669 26.6592 11.6226 8.3937C11.1618 8.03315 10.6511 8.0411 10.2498 8.25411L10.2502 8.25452C14.6522 16.3155 29.2948 30.5955 49.5441 31.3299L51.9932 32.6416V36.3659C51.9932 36.9507 52.6789 37.2666 53.1233 36.8864L62.3043 29.0334C62.3794 28.9692 62.4398 28.8894 62.4812 28.7996C62.5226 28.7098 62.544 28.6121 62.5441 28.5132C62.5441 28.4143 62.5228 28.3166 62.4815 28.2268C62.4402 28.1369 62.3799 28.0571 62.3048 27.9927Z",
    fill: "#FB9C46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9726 65.0206H1.0274C0.754915 65.0206 0.493592 64.9124 0.300918 64.7197C0.108243 64.527 0 64.2657 0 63.9932C0 63.7207 0.108243 63.4594 0.300918 63.2667C0.493592 63.0741 0.754915 62.9658 1.0274 62.9658H68.9726C69.5401 62.9658 70 63.4257 70 63.9932C70 64.2657 69.8918 64.527 69.6991 64.7197C69.5064 64.9124 69.2451 65.0206 68.9726 65.0206Z",
    fill: "#FB9C46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1667 62.9282H63.2232V52.9797C63.2232 52.2232 62.6099 51.6099 61.8533 51.6099H54.5366C53.78 51.6099 53.1667 52.2232 53.1667 52.9797V62.9282Z",
    fill: "#6E44FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7034 62.9283H47.7598V45.5027C47.7598 44.7461 47.1465 44.1328 46.3899 44.1328H39.0732C38.3167 44.1328 37.7034 44.7461 37.7034 45.5027V62.9283Z",
    fill: "#6E44FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2401 62.9282H32.2966V38.0256C32.2966 37.269 31.6833 36.6558 30.9267 36.6558H23.61C22.8534 36.6558 22.2401 37.269 22.2401 38.0256V62.9282Z",
    fill: "#6E44FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77673 62.9282H16.8332V30.5486C16.8332 29.792 16.2199 29.1787 15.4633 29.1787H8.1466C7.39002 29.1787 6.77673 29.792 6.77673 30.5486V62.9282Z",
    fill: "#6E44FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.d6f10866873c90273c5ebe73b031b6a8.svg";
export { ForwardRef as ReactComponent };